import { useEffect } from 'react';
import { useAdvancedTracking } from '@/hooks/useAdvancedTracking';
import { useScrollTracking } from '@/hooks/useScrollTracking';
import { useInitGTM } from '@/hooks/useInitGTM';

export const TrackingProvider = ({ children }: { children: React.ReactNode }) => {
  useAdvancedTracking();
  useScrollTracking();

  return <>{children}</>;
};
